/** DAT-Reifenhersteller-IDs. Wird sowohl im Frontend (Dropdown) als auch im Backend (DAT-API) verwendet. */
export const REIFENHERSTELLER_ID: Record<string, number> = {
  Alliance: 1180,
  Apollo: 1000,
  Avon: 40,
  Barum: 14,
  Berlin: 1140,
  'Berlin Tires': 1170,
  'BF-Goodrich': 80,
  Bridgestone: 3,
  Ceat: 980,
  'Cheng Shin': 1040,
  Continental: 160,
  Cooper: 810,
  CST: 1130,
  Dayton: 850,
  Debica: 950,
  Dunlop: 200,
  Eurospeed: 2,
  Falken: 940,
  Firestone: 280,
  'First Stop': 840,
  Formula: 1100,
  Fulda: 320,
  General: 19,
  Gislaved: 920,
  Giti: 1110,
  Goodyear: 4,
  'GT Radial': 960,
  Hankook: 13,
  Kleber: 480,
  Kormoran: 880,
  Kumho: 5,
  Laufenn: 1080,
  Mabor: 1030,
  Maloya: 6,
  Marangoni: 990,
  Marshal: 16,
  Matador: 15,
  Maxxis: 820,
  Metzeler: 560,
  Michelin: 600,
  Momo: 1070,
  Nexen: 970,
  Nokian: 17,
  Pirelli: 640,
  Pneumant: 830,
  Ricken: 7,
  Riken: 900,
  Sava: 18,
  Seiberling: 1020,
  Security: 1120,
  Semperit: 8,
  Sonstiger: 1,
  Sportiva: 910,
  Starfire: 860,
  Starmaxx: 1060,
  Sumitomo: 1150,
  Syron: 930,
  'Syron Tires': 1160,
  Taurus: 1010,
  Tecar: 870,
  Tigar: 890,
  Tomason: 1090,
  Toyo: 9,
  Uniroyal: 800,
  Viking: 11,
  Vredestein: 10,
  Westlake: 1050,
  Yokohama: 12
};

export const REIFENHERSTELLER_NAMEN = Object.keys(REIFENHERSTELLER_ID).sort();
